import { trackClick } from 'shared_critical/tracking/shared/clicks';

export var accordionClick = function() {
  const timeout = 400; 
  const moduleType = $(this).data('module-type');
  setTimeout(() => { 
    MOVE.LDP.RightRailBC.getAdPosition();
  }, timeout);

  if (moduleType) {
    const propertyStatus = MOVE_DATA.propertyDetails.status || 'unknown';
    const accordionCollaspe = $(this).hasClass('collapsed') ? 'expand' : 'collapse';
    const omtag = `${propertyStatus}:ldp:${moduleType}:${accordionCollaspe}`;
    trackClick(omtag, propertyStatus)
  }
}



// WEBPACK FOOTER //
// ./shared_non_critical/accordion_tracking_helper.js